<template>
  <div class="follw-box" :class="{pointer: !has_sub}" @click="has_sub ? '' : toSub()">
    <div class="l">
      <img
        src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-07-16/c820b90d1364615bea60e83965d93713.png"
        alt=""
      /><span>{{ titleLists[type] }}</span>
    </div>
    <div class="r" v-if="(type == 0) && !has_sub">
      <span>去关注</span
      ><img
        src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-07-16/01e5805e1c182562b929b1ab56144353.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import { isMobile } from "@/utils/common";
export default {
  props: {
    answer: {
      type: Boolean,
      default: false
    },
    has_sub: {
      type: Number,
      default: 0
    },
    type: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isMobile: isMobile(),
      show: false,
      titleLists: [
        "关注公众号接收作答提醒",
        "简答题批改中，请关注公众号接收通知 >",
        "简答题批改中，请留意立吉答题公众号批改通知"
      ]
    };
  },
  methods: {
    toSub() {
      let url = "https://mp.weixin.qq.com/s/j9hHKHMYCZDZmulLZzql5w";
      if (this.isMobile) {
        window.location.href = url;
      } else {
        window.open(url);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.follw-box {
  height: 40px;
  border-radius: 0px 0px 4px 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
  background: #fffcef;
  padding: 0px 10px;
  color: #ff8f1f;
}
.l {
  display: flex;
  align-items: center;
}
.l img {
  width: 15px;
  height: 15px;
  margin-right: 5px;
}
.r {
  display: flex;
  align-items: center;
}
.r img {
  width: 12px;
  height: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/subBox.vue